import * as onClick from './onClick.js';

export function pointerClick(event) {
  onClick.onClick(this, event);
}
